const actions = {
	
    // ////////////////////////////////////////////
    // CUSTOM
    // ////////////////////////////////////////////
	
}

export default actions
